module.exports = __webpack_public_path__ + "static/media/bread_bot.7175a096.png";